import React from "react";
import { useIntl, defineMessages, FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle
} from "@fluentui/react-components";
import { CloseButton } from "../input/CloseButton";

export const LeaveReason = {
  leaveRoom: "leaveRoom",
  joinRoom: "joinRoom",
  createRoom: "createRoom"
};

const reasonMessages = defineMessages({
  [LeaveReason.leaveRoom]: {
    id: "leave-room-modal.leave-room.message",
    defaultMessage: "Are you sure you want to leave?"
  },
  [LeaveReason.joinRoom]: {
    id: "leave-room-modal.join-room.message",
    defaultMessage: "Joining a new room will leave this one. Are you sure?"
  },
  [LeaveReason.createRoom]: {
    id: "leave-room-modal.create-room.message",
    defaultMessage: "Creating a new room will leave this one. Are you sure?"
  }
});

const confirmationMessages = defineMessages({
  [LeaveReason.leaveRoom]: {
    id: "leave-room-modal.leave-room.confirm",
    defaultMessage: "Leave"
  },
  [LeaveReason.joinRoom]: {
    id: "leave-room-modal.join-room.confirm",
    defaultMessage: "Join Verse"
  },
  [LeaveReason.createRoom]: {
    id: "leave-room-modal.create-room.confirm",
    defaultMessage: "Leave and Create Room"
  }
});

export function LeaveRoomModal({ reason, onClose, onLeave }) {
  const intl = useIntl();

  const leaveRoomOrInformParentWindow = e => {
    e.preventDefault();

    window.postMessage({ type: "leave-room" }, "*");

    if (onLeave) return onLeave();

    window.location.reload();
  };

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle action={<CloseButton onClick={onClose} />}>
            <FormattedMessage id="leave-room-modal.title" defaultMessage="Leave Verse" />
          </DialogTitle>
          <DialogContent>
            <p>{intl.formatMessage(reasonMessages[reason])}</p>
          </DialogContent>
          <DialogActions>
            <Button appearance="outline" onClick={onClose}>
              <FormattedMessage id="button.cancel" defaultMessage="Stay" />
            </Button>
            <Button onClick={leaveRoomOrInformParentWindow} appearance="primary" rel="noopener noreferrer">
              {intl.formatMessage(confirmationMessages[reason])}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

LeaveRoomModal.propTypes = {
  reason: PropTypes.string,
  onClose: PropTypes.func,
  onLeave: PropTypes.func
};
